var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{staticClass:"expandable-panel",attrs:{"flat":!_vm.isExpandable}},[_c('v-expansion-panel',{attrs:{"disabled":!_vm.isExpandable}},[_c('v-expansion-panel-header',{attrs:{"color":_vm.headingColor}},[_vm._v(" "+_vm._s(_vm.title)+" "),_vm._t("header")],2),_c('v-expansion-panel-content',[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }